// Lib
import React from 'react';

const TicketsCreationFormConfiguration = props => {
    const token = localStorage.getItem('iot_rocket_access_JWT');
    const deviceId = 'b62318f4d79d0de7c5f36298';
    const workspace = window.location.hostname.split('.')[0];
    return (
        <iframe
            style={{ width: '100%', height: '80vh', border: 'none' }}
            src={`https://prototypes.merciyanis.dev/kanban?token=${token}&deviceId=${deviceId}&workspace=${workspace}&view=form-config`}
            title="Tickets Creation Form Configuration"
        />
    );
};

export default TicketsCreationFormConfiguration;
